export const updateShiftAction = (state) => {
  return {
    type: "UPDATE_SHIFT",
    payload: state,
  };
};
